module.exports = __webpack_public_path__ + "img/portada.f412a4db.png";